import { globals, template } from '@yola/ws-sdk';
import saveSite from 'src/js/modules/saving/helpers/save-site';
import store from '../../../store';
import constants from '../constants/common';

const setLanguageSelector = (markup, mainLocale) => {
  const state = store.getState();
  const { globalId } = template.selectors.getVariableValueByPath(state, 'languageSelector[0]');
  const languageSelector = document.createElement(constants.LANGUAGE_SELECTOR_TAG);

  languageSelector.appendChild(markup);
  languageSelector.dataset.mainLang = mainLocale;

  store.dispatch(globals.actions.setGlobalHTML(globalId, languageSelector.outerHTML));
  saveSite();
};

export default setLanguageSelector;
